import { motion } from 'framer-motion';
import styles from './ScanProgress.module.css';

interface ScanProgressProps {
  url: string;
  progress: number;
  status: string;
}

const ScanIcon = () => (
  <svg className={styles.icon} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83" />
  </svg>
);

export function ScanProgress({ url, progress, status }: ScanProgressProps) {
  const stages = ['Security', 'Performance', 'Compliance', 'Technical'];
  const currentStage = Math.floor((progress / 100) * stages.length);

  return (
    <div className={styles.container}>
      <motion.div
        className={styles.card}
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.4 }}
      >
        <motion.div
          className={styles.iconWrapper}
          animate={{ rotate: 360 }}
          transition={{ duration: 2, repeat: Infinity, ease: 'linear' }}
        >
          <ScanIcon />
        </motion.div>

        <p className={styles.url}>{url}</p>

        <h2 className={styles.title}>Analyzing Website</h2>
        <p className={styles.status}>{status}</p>

        <div className={styles.progressWrapper}>
          <div className={styles.progressBar}>
            <motion.div
              className={styles.progressFill}
              initial={{ width: 0 }}
              animate={{ width: `${progress}%` }}
              transition={{ duration: 0.5, ease: 'easeOut' }}
            />
          </div>
          <p className={styles.percentage}>{Math.round(progress)}%</p>
        </div>

        <div className={styles.stages}>
          {stages.map((stage, index) => (
            <motion.div
              key={stage}
              className={`${styles.stageDot} ${index < currentStage ? styles.complete : ''} ${index === currentStage ? styles.active : ''}`}
              initial={{ scale: 0 }}
              animate={{ scale: 1 }}
              transition={{ delay: index * 0.1 }}
              title={stage}
            />
          ))}
        </div>
      </motion.div>
    </div>
  );
}
